import i18next from 'i18next'

export function getCurrentLanguage(fallback = 'en') {
  return i18next.language || (i18next.languages && i18next.languages[0]) || fallback
}
